import React from 'react';
import {Backdrop, Fade, Modal} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '25px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    zIndex: 1,
  },
}));

export default function CreateAudienceSuccess() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <div>
        <div onClick={handleOpen}>
          {/*react-transition-group*/}
          Save
        </div>
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <div
                  className={'audienceBlock addContactBlock addContactBlockSuccess'}>
                <img alt="contact successful" onClick={handleClose}
                     className={'closeImg contactSuccessfulImg'}
                     src={require("../../../assets/images/Group41.png").default}/>
                <div className={'successfulImport'}>

                  <h2 id="simple-modal-title" className={'addContactTitle'}>
                    <p>Contact Successfully</p>
                    <p>Added!</p>
                  </h2>
                  <img alt="component" src={require("../../../assets/images/Component6.png").default}/>
                </div>
              </div>
            </div>
          </Fade>
        </Modal>
      </div>
  );
}